import { useMemo } from 'react'

import type { StorageResource } from '@campai/lib-common/entities'
import { createUserActor } from '@campai/lib-common/utils/actor'

export const useUserActor = ({
    userId,
    name,
    avatar,
}: {
    userId: string
    name: string
    avatar?: StorageResource | string | null
}) => {
    const resource = typeof avatar === 'string' ? avatar : avatar?.resource

    return useMemo(
        () => createUserActor({ userId, name, avatar: resource ? { resource } : null }),
        [userId, name, resource]
    )
}
